import util from '@bmp-vue/core/api/util'
// import ui from '@bmp-vue/core/api/ui'

const controller = 'Onboarding'
const ctrl = Object.assign({}, util.GetCrud(controller, ['none']), {
  TipoConta: [
    { text: 'Conta Escrow', value: 2 },
    { text: 'Conta Movimento', value: 1 }
  ],
  TipoPessoaFiltro: [
    { text: 'Pessoa física', value: 1 },
    { text: 'Pessoa jurídica', value: 2 }
  ],
  PeriodoFiltro: [
    { text: 'Últimos 7 dias', value: 7 },
    { text: 'Últimos 15 dias', value: 15 },
    { text: 'Últimos 30 dias', value: 30 }
  ],
  MaxFileSize: '8MB',
  MaxFileSizeIB: '12MB',
  MaxFiles: 5,
  AcceptedFiles: '.pdf,  image/jpg, image/jpeg, image/png',
  TipoDocumentoSocioEnum: {
    Procuracao: 1,
    Identificacao: 2
  },
  TipoArquivoUploadEnum: {
    CorrentistaPJSocio: 0,
    Correntista: 1,
    CorrentistaPJSocio_TermoAceite: 2,
    Correntista_TermoAceite: 3
  },
  RulesDoc: [(file) => file?.name.length <= 60 || 'O nome do arquivo deve conter no máximo 60 caracteres.', (file) => ('application/pdf, image/jpeg, image/jpg, image/png').includes(file?.type) || `O tipo de arquivo ${file?.type} é inválido.`],
  async GetTemplateBase64 (th, codigoIntegracaoDbs, raw) {
    const pdfString = await th.$api.Dbs.GetTermoAceite(codigoIntegracaoDbs)
    return raw ? pdfString : 'data:application/pdf;base64,' + pdfString + '#toolbar=0'
  },
  GetFileBase64 (file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const base64String = reader.result.split(',')[1];
        resolve(base64String);
      };
      reader.readAsDataURL(file);
    });
  },
  UploadDocumento (th, file, tipoArquivo, parametros, callback) {
    if (file && parametros) {
      if (file.name.length <= 60 && ('application/pdf, image/jpeg, image/jpg, image/png').includes(file?.type)) {
        ctrl.GetFileBase64(file).then(async (arquivoBase64) => {
          const dto = {
            FileContent: arquivoBase64,
            FileName: file.name,
            TipoArquivo: tipoArquivo,
            Parameters: parametros,
          };
          try {
            const response = await th.$api.Dbs.PostFile(dto);
            if (!response.success) {
              switch (tipoArquivo) {
                case ctrl.TipoArquivoUploadEnum.Correntista:
                  th.$set(th.model, 'arquivoCorrentista', null)
                  break;
                case ctrl.TipoArquivoUploadEnum.CorrentistaPJSocio: {
                  const socio = th.model.Socios.find(socio => socio.documentoFederal === parametros.DocumentoFederal)
                  th.$set(socio, 'arquivoSocio', null)
                }
              }
              th.$api.UI.ShowError('Erro', response.message || response.error);
            }
            if (callback) {
              callback(response.success)
            }
          } catch (error) {
            th.$api.UI.ShowError('Erro', 'Erro ao realizar o upload do arquivo');
          }
        }).catch(_ => {
          callback('Sem Alteração')
        });
      }
    }
  },
  async UploadDocumentos (th, files, tipoArquivo, parametros, callback) {
    if (!files || !Array.isArray(files) || files.length === 0) {
      th.$api.UI.ShowAlert('Nenhum arquivo importado.')
      return
    }
    var sendFiles = files.filter(file => !file?.aws)
    if (sendFiles.length === 0) {
      th.$api.UI.ShowSuccess('Arquivos enviados com sucesso!')
      if (callback) callback(true)
      return
    }
    const formData = new FormData()
    sendFiles.forEach(file => {
      formData.append('files', file)
    })
    Object.keys(parametros).forEach(key => {
      formData.append(key, parametros[key]);
    });

    try {
      const { response, success, message, error } = await th.$api.Dbs.UploadDocumentos(formData)

      if (error) {
        switch (tipoArquivo) {
          case ctrl.TipoArquivoUploadEnum.Correntista:
            th.$set(th.model, 'arquivoCorrentista', [])
            th.arquivosAdicionados = []
            break;
          case ctrl.TipoArquivoUploadEnum.CorrentistaPJSocio: {
            const socio = th.model.Socios.find(socio => socio.documentoFederal === parametros.documentoFederal)
            th.$set(socio, 'arquivoSocio', [])
            th.arquivosAdicionados = []
            break
          }
        }
        throw message || error || response
      }
      if (success) {
        var documentosImportados = sendFiles.map(file => {
          var infoFile = response.documentos.find(arquivo => arquivo.localArquivo.split('/').at(-1) === file.name)
          return {
            name: file.name,
            codigo: infoFile.codigo,
            path: infoFile.localArquivo,
            size: 0,
            aws: true
          }
        })
        th.$set(th.model, 'documentosEmpresa', [...files, ...documentosImportados])
        if (callback) callback(success)
        th.$api.UI.ShowSuccess('Arquivos enviados com sucesso!')
      } else {
        th.$api.UI.ShowError('Erro', 'Erro ao realizar o upload dos arquivos');
      }
    } catch (error) {
      th.$api.UI.ShowError('Erro', 'Erro ao realizar o upload dos arquivos');
    }
  },
  async AceitarTermo (th, tipoArquivo, codigo, pessoa, callback) {
    let parameters = {}

    let codigoParceiro = th.params?.codigoParceiro || (th.$empresa.codigoParceiro ?? JSON.parse(localStorage.params).codigoParceiro);

    if (tipoArquivo === ctrl.TipoArquivoUploadEnum.Correntista_TermoAceite) {
      codigoParceiro = codigo
      parameters = {
        DocumentoFederal: pessoa.documento,
        CodigoParceiro: codigo,
        CodigoOperador: th.model.codigoOperadorCriacao || th.model.codigoOperador,
        CodigoSolicitacao: th.model.codigoSolicitacao || th.model.params.codigoSolicitacaoCriacao,
      }
    } else if (tipoArquivo === ctrl.TipoArquivoUploadEnum.CorrentistaPJSocio_TermoAceite) {
      parameters = {
        DocumentoFederal: pessoa.documento,
        CodigoOperador: th.model.codigoOperadorCriacao || th.model.codigoOperador,
        CodigoSolicitacao: th.model.codigoSolicitacao || th.model.params.codigoSolicitacaoCriacao,
      }
    }

    const dtoAssinaturaAceite = {
      Nome: pessoa.nome,
      Email: pessoa.email,
      TitularConta: pessoa.titular,
      DocumentoFederal: pessoa.documento,
      TipoArquivo: tipoArquivo,
      CodigoIntegracaoDbs: codigoParceiro,
      Parameters: parameters,
    }

    await th.$api.Dbs.AssinarAceiteTermo(dtoAssinaturaAceite).then((resp) => {
      if (resp.success) {
        callback()
      } else {
        th.$api.UI.ShowError('Erro', 'Problema na assinatura do termo.')
      }
    })
  },
  findRecordSolicitacao (th, codigoSolicitacao, isEdicao = true) {
    th.$api.Dbs.Get(`contas-solicitacao-criacao/solicitacao-completa/${codigoSolicitacao}`).then(({ success, response }) => {
      if (success) {
        if (isEdicao) {
          th.$set(th, 'tipoFluxo', {
            TipoPessoa: response.titular.tipoPessoa,
            TipoConta: response.contaSolicitacao.modeloConta,
            TipoCadastro: response.contaSolicitacao.tipoPreenchimento
          })
        }
        th.$set(th, 'model', {
          ...th.model,
          isEdicao: isEdicao,
          codigoSolicitacaoConta: response.contaSolicitacao.codigo,
          codigoSubparceiro: response.contaSolicitacao.codigoSubparceiro,
          situacao: response.contaSolicitacao.situacao,
          codigoOperadorCriacao: response.contaSolicitacao.codigoOperadorCriacao,
          codigoOperador: response.contaSolicitacao.codigoOperadorCriacao,
          codigoCorrentista: response.correntista?.codigoPessoaDado,
          Pessoa: {
            ...response.titular,
            ...response.correntista,
            indicadorPEP: response.correntista?.pf?.indicadorPEP,
            pf: response.correntista?.pf || {},
            pj: response.correntista?.pj || {},
            endereco: response.correntista?.endereco || {},
            TipoPessoa: response.titular.tipoPessoa,
            TipoConta: response.contaSolicitacao.modeloConta,
            TipoCadastro: response.contaSolicitacao.tipoPreenchimento,
            codigoOperadorCriacao: response.contaSolicitacao.codigoOperadorCriacao,
          },
        })
        if (response.contaSolicitacao.modeloConta === th.$aux.TipoContaOnboardingEnum.Escrow) {
          th.$set(th.model, 'conta', {
            codigo: response.contaSolicitacao.codigoConta,
            agencia: response.contaSolicitacao.numeroAgencia,
            digitoAgencia: response.contaSolicitacao.digitoAgencia,
            banco: response.contaSolicitacao.numeroBanco,
            contaPagamento: response.contaSolicitacao.contaPagamento.slice(0, -1) + '-' + response.contaSolicitacao.contaPagamento.slice(-1)
          })
          th.$set(th.model, 'Operadores', response.operadoresFrontEnd)
          if (response.credor) th.$set(th.model, 'Credor', response.credor)
        } else {
          th.$set(th.model, 'dadosPreenchedor', response.preenchedor)
        }
        if (response.controlador) {
          th.$set(th.model, 'Controlador', {
            codigoControlador: response.controlador.codigoPessoaDado,
            documentoFederal: response.controlador.documentoFederal,
            nome: response.controlador.razaoSocial,
            email: response.controlador.email,
            situacao: response.controlador.situacao,
            telefoneCelular: response.controlador.telefoneCelular,
            tipoEmpresa: response.controlador.tipoEmpresa,
            endereco: {
              bairro: response.controlador.bairro,
              cep: response.controlador.cep,
              cidade: response.controlador.cidade,
              complemento: response.controlador.complemento,
              logradouro: response.controlador.logradouro,
              nroLogradouro: response.controlador.nroLogradouro,
              uf: response.controlador.uf
            }
          })
        }

        if (response.titular.tipoPessoa === th.$aux.TipoPessoaEnum.PJ && response.socios?.length > 0) {
          th.$set(th.model, 'Socios', response.socios)
        }

        if (response.correntista.pj?.localArquivoContratoSocial && response.correntista.pj?.localArquivoContratoSocial.length > 0) {
          var files = response.correntista.pj.localArquivoContratoSocial.map((filePath, index) => {
            return {
              name: response.correntista.pj.nomeArquivoContratoSocial[index],
              path: filePath,
              codigo: response.correntista.pj.codigoArquivoContratoSocial[index],
              size: 0,
              aws: true
            }
          })
          th.$set(th.model, 'documentosEmpresa', files)
        }
      }
    })
  },
  cleanObj (obj) {
    return Object.entries(obj).reduce((acc, [key, value]) => {
      if (
        value !== null &&
        value !== undefined &&
        !(Array.isArray(value) && value.length === 0) &&
        !(typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length === 0)
      ) {
        acc[key] = value;
      }
      return acc;
    }, {});
  },
  responseHandler (res) {
    if (res.response && res.response.errors) {
      return res.response.errors[0].detail ? res.response.errors[0].detail : res.response.title
    } else {
      return 'Erro ao processar sua solicitação!'
    }
  },
  handleResponseContato (th, res, callback) {
    const msg = ctrl.responseHandler(res)
    const regex = /\b(e-?mail|telefone)\b/i;
    if (regex.test(msg)) {
      ctrl.openModalOperador(th, 'Não foi possível concluir o cadastro', msg)
      if (callback) callback(msg)
    } else {
      th.$api.UI.ShowError('Erro', msg)
    }
  },
  openModalOperador (th, title, text) {
    th.$store.dispatch('onboarding/openModal', {
      title: title,
      text: text,
    })
  },
  async GetParameters (th) {
    const codigoPortal = JSON.parse(localStorage.getItem('empresa')).codigoPortal;
    const codigoEmpresa = await th.$api.Empresa.GetAllByCodigoPortal(codigoPortal)
    const dtoParams = {
      parameters: [
        { name: 'codigoEmpresa', value: codigoEmpresa[0].codigo }
      ]
    }
    const parametros = {}
    const responseParam = await th.$api.Parametro.GetAll(dtoParams)
    responseParam.forEach(p => {
      try {
        parametros[p.identificador] = JSON.parse(p.valor)
      } catch {
        parametros[p.identificador] = p.valor
      }
    })
    return parametros
  },
  async GetParametersByCustomizacao (th, codigoPortal) {
    const parametros = {}
    const responseParam = await th.$api.Parametro.GetAllByPortal(codigoPortal)
    responseParam.forEach(p => {
      try {
        parametros[p.identificador] = JSON.parse(p.valor)
      } catch {
        parametros[p.identificador] = p.valor
      }
    })
    return parametros
  },
  enviaEmailSocios (th, callback) {
    function validacaoAssinante (socio) {
      return socio.tipoAssinatura === th.$aux.TipoAssinaturaSocioCorrentistaPJEnum.EmConjunto || socio.tipoAssinatura === th.$aux.TipoAssinaturaSocioCorrentistaPJEnum.Isoladamente
    }
    const emailPromises = th.model.Socios.filter(socio => validacaoAssinante(socio)).map(socio => {
      const dto = {
        Acao: 'ValidacaoBiometricaPJ',
        To: socio.email,
        CodigoParceiro: th.$empresa.codigoParceiro || th.model.params.codigoParceiro,
        Ambiente: th.$empresa.ambiente || th.model.params.ambiente,
        CodigoSolicitacaoCriacao: th.model.codigoSolicitacaoConta || th.model.params.codigoSolicitacaoCriacao,
        TipoPessoa: th.model.Pessoa.TipoPessoa || th.model.Pessoa.tipoPessoa,
        DocumentoFederalCorrentista: th.$api.UI.Format.SomenteNumeros(th.model.Pessoa.documentoFederal) || '',
        Variables: [
          { name: 'NOME', value: socio.nome },
          { name: 'TITULAR', value: th.model.Pessoa.nomeFantasia || th.model.Pessoa.nome }
        ]
      }
      return dto
    })
    th.$api.CentralEmailMultiplo.EnviarEmailByParceiroBucket(emailPromises).then(response => {
      if (response.success) {
        if (callback) callback()
      } else {
        th.$api.UI.ShowError('Erro', 'Erro ao enviar e-mail')
      }
    })
  },
  verificaDados (info) {
    return !info || info.trim() === ' ' ? '-' : info
  },
  async validarLimiteAberturaDeConta (th, documento, codigoParceiro, callback) {
    const path = `parceiros/validar-limite/${codigoParceiro}`;
    const queryParameters = {
      codigoParceiro: codigoParceiro,
      documentoFederal: th.$api.UI.Format.SomenteNumeros(documento),
    };
    const response = await th.$api.Dbs.Get(path, queryParameters);
    if (response.success) {
      return true;
    } else {
      callback(response.response.mensagem);
      return false;
    }
  },
})
export default ctrl
